import api from './api';

class DashboardService {
    /**
     * Get dashboard statistics
     * Returns: { totalProducts, totalOrders, pendingApprovals, totalRevenue }
     */
    async getStats() {
        try {
            console.log(`📊 Fetching stats from: /admin/dashboard/stats`);
            const response = await api.get('/admin/dashboard/stats');
            console.log('✓ Stats fetched successfully:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Stats error:', error.message);
            throw this.handleError(error);
        }
    }

    /**
     * Get sales chart data
     * @param {number} start_date - Start date in milliseconds
     * @param {number} end_date - End date in milliseconds
     * Returns: Array of { name, sales, orders }
     */
    async getSalesChart(start_date, end_date) {
        try {
            const url = `/admin/dashboard/sales-chart?start_date=${start_date}&end_date=${end_date}`;
            console.log(`📈 Fetching chart from: ${url}`);

            const response = await api.get(url);

            console.log(`✓ Chart fetched successfully: ${response.data.length} data points`);
            return response.data;
        } catch (error) {
            console.error('❌ Chart error:', error.message);
            if (error.response) {
                console.error('   Status:', error.response.status);
                console.error('   Data:', error.response.data);
            }
            throw this.handleError(error);
        }
    }

    handleError(error) {
        if (error.response) {
            throw new Error(error.response.data.error || error.response.data.message || 'An error occurred');
        } else if (error.request) {
            throw new Error('Network error. Please check your connection.');
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
}

export default new DashboardService();
